import { render, staticRenderFns } from "./Adquisicion.vue?vue&type=template&id=2e842423&scoped=true&lang=html&"
import script from "./Adquisicion.vue?vue&type=script&lang=js&"
export * from "./Adquisicion.vue?vue&type=script&lang=js&"
import style0 from "./Adquisicion.vue?vue&type=style&index=0&id=2e842423&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e842423",
  null
  
)

export default component.exports